import { LucideIconData } from 'lucide-angular';

export const PoolCaC1: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M7 10 L12 6 L17 10 V16 a1 1 0 0 1 -1 1 H8 a1 1 0 0 1 -1 -1 Z' }],
];
